import { useFormikContext } from "formik";
import { Stack, TextField } from "@mui/material";
import SingleCountrySelect from "../../../common/SingleCountrySelect";
import { AddClientFormValues } from "../../types";

const style = {
  sectionLayout: { paddingBottom: "1%", minWidth: "48%" },
};

const ClientAddressDetails = () => {
  const { handleChange, values, errors, touched } =
    useFormikContext<AddClientFormValues>();

  return (
    <>
      <Stack
        flexWrap="wrap"
        data-testid="client-address-fields"
        justifyContent="space-between"
        alignContent="left"
        alignItems="center"
        direction="row"
      >
        <TextField
          id="address-street"
          label="Street"
          variant="standard"
          sx={style.sectionLayout}
          value={values["address-street"]}
          onChange={handleChange}
          autoComplete="disabled"
        />
        <TextField
          id="address-city"
          label="City"
          variant="standard"
          sx={style.sectionLayout}
          autoComplete="disabled"
          value={values["address-city"]}
          onChange={handleChange}
          error={touched["address-city"] && Boolean(errors["address-city"])}
          helperText={touched["address-city"] && errors["address-city"]}
        />
        <TextField
          id="address-zip-code"
          label="Postcode"
          variant="standard"
          sx={style.sectionLayout}
          autoComplete="disabled"
          value={values["address-zip-code"]}
          onChange={handleChange}
          error={
            touched["address-zip-code"] && Boolean(errors["address-zip-code"])
          }
          helperText={touched["address-zip-code"] && errors["address-zip-code"]}
        />
        <SingleCountrySelect />
      </Stack>
    </>
  );
};

export default ClientAddressDetails;
